<script setup>
import { useStore } from 'vuex'
import LoadsLineChart from '@/components/loads/LoadsLineChart.vue'
import LoadsData from '@/components/loads/LoadsData.vue'
import TabTemplate from '@/components/common/TabTemplate.vue'
import { computed, onMounted, watch } from 'vue'

const store = useStore()

const currentStabSchematisationStage = computed(
  () => store.state.stabSchematisationStage.currentItem
)

watch(
  () => currentStabSchematisationStage.value,
  async () => {
    await fetchItemsPage()
  }
)

const fetchTopoProfilePointOptions = async () =>
  await store.dispatch('topoProfilePoint/fetchOptions')
const fetchTopoProfilePointItems = async (id) =>
  await store.dispatch('topoProfilePoint/fetchItems', id)
const fetchTopoProfileItem = async (id) => await store.dispatch('topoProfile/fetchItem', id)
const fetchItemsUniformLoads = async (id) => await store.dispatch('uniformLoads/fetchItems', id)
const fetchOptionsUniformLoads = async () => await store.dispatch('uniformLoads/fetchOptions')
const fetchItemsTreeLoads = async (id) => await store.dispatch('treeLoads/fetchItems', id)
const fetchOptionsTreeLoad = async () => await store.dispatch('treeLoads/fetchOptions')

const fetchItemsPage = async () => {
  try {
    await fetchTopoProfilePointOptions()
    await fetchOptionsUniformLoads()
    await fetchOptionsTreeLoad()
    await fetchTopoProfileItem(currentStabSchematisationStage.value.topoprofile)
    await fetchTopoProfilePointItems(currentStabSchematisationStage.value.topoprofile)
    await fetchItemsUniformLoads(currentStabSchematisationStage.value.id)
    await fetchItemsTreeLoads(currentStabSchematisationStage.value.id)
  } catch (e) {
    console.log(e)
  }
}

onMounted(async () => {
  await fetchItemsPage()
})
</script>

<template>
  <TabTemplate>
    <template v-slot:chart>
      <LoadsLineChart ref="chart" />
    </template>
    <template v-slot:content>
      <LoadsData />
    </template>
  </TabTemplate>
</template>
